/**
 * Created by CCristi <ccovali@mitocgroup.com> on 2/16/16.
 */

'use strict';

/**
 * Shared Key
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let SharedKey = exports.SharedKey = function () {
  /**
   *
   * @param {String} keyString
   * @param {Instance} microservice
   */
  function SharedKey(keyString, microservice) {
    _classCallCheck(this, SharedKey);

    this._key = keyString;
    this._microservice = microservice;
  }

  /**
   * @returns {Instance}
   */


  _createClass(SharedKey, [{
    key: 'toString',


    /**
     * @returns {String}
     */
    value: function toString() {
      return this._key;
    }
  }, {
    key: 'microservice',
    get: function get() {
      return this._microservice;
    }
  }]);

  return SharedKey;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/SharedKey.js
// module id = 160
// module chunks = 0